import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/blank-message.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2b3bfc0b")

_pushScopeId("data-v-2b3bfc0b")
const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { class: "w-full text-xs text-gray-500" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_7 = {
  key: 1,
  class: "font-medium"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "mx-1" }, "生徒画面", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("path", { d: "M19 9l-7 7-7-7" }, null, -1)
const _hoisted_10 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_11 = {
  key: 0,
  class: "flex-grow flex-shrink flex flex-col-reverse px-4 overflow-y-scroll"
}
const _hoisted_12 = {
  key: 0,
  class: "flex flex-shrink-0 justify-center py-4"
}
const _hoisted_13 = {
  key: 1,
  class: "flex-1 w-full flex flex-col justify-center items-center"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Blank Notification",
  class: "w-1/2 mb-4"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-400 px-4 text-center" }, [
  /*#__PURE__*/_createTextVNode(" この生徒とのメッセージはまだありません。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("最初のメッセージを開始しましょう！ ")
], -1)
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col pt-3 pb-1 border-t border-primary-100"
}
const _hoisted_17 = {
  key: 0,
  class: "pt-3 pb-1 px-2 bg-white border-t border-primary-100"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "p-3 mt-2 mx-2 bg-red-100 rounded-md text-sm" }, " 独自公式LINEを利用しているスクールの生徒のため、管理人からメッセージを送信することはできません。 ", -1)
const _hoisted_19 = {
  key: 1,
  class: "flex items-start lg:items-end pb-1 px-2 bg-white"
}
const _hoisted_20 = { class: "flex-1 flex flex-col relative mr-3" }
const _hoisted_21 = {
  key: 0,
  class: "flex w-full mb-2 overflow-x-scroll"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("path", { d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" }, null, -1)
const _hoisted_23 = { class: "w-full mt-2 bottom-1 flex justify-between items-center rounded-md" }
const _hoisted_24 = {
  key: 0,
  class: "ml-2 text-xs text-secondary-500"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = {
  for: "image",
  class: "p-1 text-gray-500 transition-all duration-300 cursor-pointer hover:text-primary-500"
}
const _hoisted_28 = {
  key: 2,
  class: "pt-3 pb-1 px-2 bg-white border-t border-primary-100"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "p-3 mt-2 mx-2 bg-red-100 rounded-md text-sm" }, " この生徒は休会中です。休会中の生徒にメッセージを送信することはできません。 ", -1)
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" を同時に押すと、絵文字一覧から絵文字の入力が可能です。 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MSMessageItem = _resolveComponent("MSMessageItem")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_speech_bubble = _resolveComponent("m-speech-bubble")
  const _component_m_message_template_sheet = _resolveComponent("m-message-template-sheet")
  const _component_m_sticker_sheet = _resolveComponent("m-sticker-sheet")
  const _component_MsChatGPTModal = _resolveComponent("MsChatGPTModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex-1 absolute lg:static transform transition-transform duration-500 lg:-translate-y-0 z-0 lg:flex flex-col h-full bg-white rounded-t-md shadow-top", _ctx.sliderCss]
    }, [
      _createVNode("div", {
        class: "flex lg:justify-between items-center px-8 py-2 h-16 border-b border-primary-100",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showOnMobile = !_ctx.showOnMobile))
      }, [
        (_ctx.student)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.student.data.name), 1),
              _createVNode("p", _hoisted_4, [
                _createTextVNode(" 累計" + _toDisplayString(_ctx.totalDayCount) + "日入室 ", 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.student.data.grade) + " ", 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.schoolInformation), 1)
              ])
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_7, "メッセージ")),
        (_ctx.student)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 2,
              color: "gray-500",
              size: "sm",
              "font-weight": "normal",
              text: "",
              link: _ctx.studentPagePath
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["link"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock("svg", {
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          class: ["w-4 h-4 ml-1 lg:hidden", _ctx.transformCss],
          viewBox: "0 0 24 24"
        }, [
          _hoisted_9
        ], 2))
      ]),
      _createVNode("div", _hoisted_10, [
        (_ctx.messages.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                return (_openBlock(), _createBlock(_component_MSMessageItem, {
                  key: message.ref.id,
                  item: message,
                  onGptMessage: _ctx.reflectMessage,
                  onOpenChatGPTConfigModal: _ctx.openChatGPTConfigModal,
                  onDelete: _ctx.deleteMessage
                }, null, 8, ["item", "onGptMessage", "onOpenChatGPTConfigModal", "onDelete"]))
              }), 128)),
              (!_ctx.messageFinished)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("div", {
                      class: "px-4 py-2 rounded-md text-gray-700 text-sm underline transition-colors duration-300 cursor-pointer hover:bg-gray-100",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getMoreMessages && _ctx.getMoreMessages(...args)))
                    }, [
                      _withDirectives(_createVNode("span", null, "さらに読み込む", 512), [
                        [_vShow, !_ctx.messageLoading]
                      ]),
                      _withDirectives(_createVNode("span", null, "読み込み中...", 512), [
                        [_vShow, _ctx.messageLoading]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15
            ])),
        (!_ctx.studentMessageSendingRestricted)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              (
              _ctx.messageUserSchoolConfig &&
                _ctx.messageUserSchoolConfig.data.allowUseOfCustomOfficialLine &&
                _ctx.isAdmin
            )
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _hoisted_18
                  ]))
                : (!_ctx.inRecess)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        (_ctx.fileUrls.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_21, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileUrls, (url, i) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: url,
                                  class: "relative w-20 h-20 mr-2"
                                }, [
                                  _createVNode("img", {
                                    src: url,
                                    alt: "Upload Image",
                                    class: "w-16 h-16 mx-2 my-2 object-cover rounded-md border-2 border-gray-200"
                                  }, null, 8, ["src"]),
                                  (_openBlock(), _createBlock("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    fill: "currentColor",
                                    class: "absolute right-0 top-0 w-5 h-5 text-gray-500 transition-colors duration-300 cursor-pointer hover:text-black",
                                    onClick: ($event: any) => (_ctx.removeImage(i))
                                  }, [
                                    _hoisted_22
                                  ], 8, ["onClick"]))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode("textarea", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newMessage = $event)),
                          name: "message",
                          placeholder: "メッセージを入力",
                          rows: "3",
                          class: "w-full bg-yellow-100 rounded border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                        }, null, 512), [
                          [_vModelText, _ctx.newMessage]
                        ]),
                        _createVNode("div", _hoisted_23, [
                          (_ctx.student)
                            ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.currentDayCountMessage), 1))
                            : (_openBlock(), _createBlock("div", _hoisted_25)),
                          _createVNode("div", _hoisted_26, [
                            (
                      _ctx.userAgent.indexOf('macintosh') !== -1 ||
                        _ctx.userAgent.indexOf('windows') !== -1
                    )
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "p-1 mr-2 transition-all duration-300 cursor-pointer text-gray-500 hover:text-primary-500",
                                  onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mouseOverAction && _ctx.mouseOverAction(...args))),
                                  onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveAction && _ctx.mouseLeaveAction(...args)))
                                }, " 絵文字 ", 32))
                              : _createCommentVNode("", true),
                            _createVNode("div", {
                              class: ["p-1 mr-2 transition-all duration-300 cursor-pointer hover:text-primary-500", {
                      'text-gray-500': !_ctx.isDisplayMessageTemplateSheet,
                      'text-primary-500': _ctx.isDisplayMessageTemplateSheet
                    }],
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (
                      _ctx.isDisplayMessageTemplateSheet = !_ctx.isDisplayMessageTemplateSheet
                    ))
                            }, [
                              _createVNode(_component_m_icon, {
                                type: "annotation",
                                size: "6"
                              })
                            ], 2),
                            _createVNode("div", {
                              class: ["p-1 mr-2 transition-all duration-300 cursor-pointer hover:text-primary-500", {
                      'text-gray-500': !_ctx.isDisplayStickerSheet,
                      'text-primary-500': _ctx.isDisplayStickerSheet
                    }],
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDisplayStickerSheet = !_ctx.isDisplayStickerSheet))
                            }, [
                              _createVNode(_component_m_icon, {
                                type: "smile",
                                size: "6"
                              })
                            ], 2),
                            _createVNode("label", _hoisted_27, [
                              _createVNode(_component_m_icon, {
                                type: "picture",
                                size: "6"
                              }),
                              _createVNode("input", {
                                id: "image",
                                type: "file",
                                accept: "image/*",
                                name: "image",
                                multiple: "",
                                class: "hidden",
                                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.imageUpload && _ctx.imageUpload(...args)))
                              }, null, 32)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("button", {
                        class: ["flex-shrink-0 rounded-md text-white font-medium px-4 py-2 focus:outline-none transition-all duration-300", _ctx.dynamicButtonCss],
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                      }, " 送る ", 2)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_28, [
                      _hoisted_29
                    ])),
              _withDirectives(_createVNode(_component_m_speech_bubble, { "triangle-position": '210px' }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.shortcutText), 1),
                  _hoisted_31
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.hoverFlag]
              ]),
              (_ctx.isDisplayMessageTemplateSheet)
                ? (_openBlock(), _createBlock(_component_m_message_template_sheet, {
                    key: 3,
                    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDisplayMessageTemplateSheet = false)),
                    onSelect: _ctx.addMessage,
                    onRegister: _ctx.openAddMessageTemplateModal
                  }, null, 8, ["onSelect", "onRegister"]))
                : _createCommentVNode("", true),
              (_ctx.isDisplayStickerSheet)
                ? (_openBlock(), _createBlock(_component_m_sticker_sheet, {
                    key: 4,
                    onSendSticker: _ctx.sendStickerImage,
                    onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isDisplayStickerSheet = false))
                  }, null, 8, ["onSendSticker"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isOpenChatGPTConfigModal)
      ? (_openBlock(), _createBlock(_component_MsChatGPTModal, {
          key: 0,
          onClose: _ctx.closeChatGPTConfigModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
})